import type { TranslationMessages } from '../../types';

export const schedule: TranslationMessages = {
  title: 'Working Schedule',
  upcoming_shifts: 'Upcoming Shifts',
  shift_details: 'Shift Details',
  shift_time: 'Shift Time',
  shift_location: 'Shift Location',
  shift_role: 'Shift Role',
  no_upcoming_shifts: 'No upcoming shifts',
  calendar_view: 'Calendar View',
  month_view: 'Month View',
  week_view: 'Week View',
  day_view: 'Day View',
  conflicts_title: 'Schedule Conflicts',
  conflicts_count: 'Schedule Conflicts (%{count})',
  conflict_overlap_description: 'Shift overlaps with existing schedule',
  conflict_overlap_resolution: 'Adjust start or end time',
  conflict_overtime_description: 'Staff member would exceed weekly hour limit',
  conflict_overtime_resolution: 'Reduce hours or assign to different staff',
  conflict_unavailable_description: 'Staff member is unavailable on this date',
  conflict_unavailable_resolution:
    'Assign to different staff member or change date',
  conflict_skill_mismatch_description:
    'Staff member lacks required skills for this position',
  conflict_skill_mismatch_resolution:
    'Assign to qualified staff or change position',
  severity_critical: 'Critical',
  severity_high: 'High',
  severity_medium: 'Medium',
  severity_low: 'Low',
  shift_title_morning: 'Morning Shift',
  shift_title_evening: 'Evening Shift',
  shift_title_weekend: 'Weekend Shift',
  location_main_store: 'Main Store',
  role_barista: 'Barista',
  role_cashier: 'Cashier',
  role_manager: 'Manager',
  controls_title: 'Calendar Controls',
  search_label: 'Search shifts',
  search_placeholder: 'Search by staff, position, location...',
  view_mode_label: 'View Mode',
  position_label: 'Position',
  position_all: 'All Positions',
  calendar_title_prefix_monthly: 'Monthly Schedule',
  calendar_title_prefix_weekly: 'Weekly Schedule',
  calendar_title_prefix_daily: 'Daily Schedule',
  calendar_title_prefix_yearly: 'Yearly Schedule',
  calendar_description_month: 'View all shifts for the month',
  calendar_description_week: 'View shifts for the week',
  calendar_description_day: 'View shifts for the selected day',
  calendar_description_year: 'View all shifts for the year',
  year_view_title: 'Year View',
  year_view_subtitle: 'All shifts for %{year}',
  month_more_label: '+%{count} more',
  month_empty_label: 'Click to add shift',
  day_empty_label: 'No shifts scheduled',
  day_add_shift: 'Add Shift',
  quick_stats_title: 'Quick Stats',
  quick_stats_scheduled_label: 'Scheduled',
  quick_stats_confirmed_label: 'Confirmed',
  quick_stats_conflicts_label: 'Conflicts',
  quick_stats_staff_label: 'Staff',
  nav_previous_year: 'Previous Year',
  nav_this_year: 'This Year',
  nav_next_year: 'Next Year',
  nav_previous_week: 'Previous Week',
  nav_this_week: 'This Week',
  nav_next_week: 'Next Week',
  nav_previous: 'Previous',
  nav_today: 'Today',
  nav_next: 'Next',
  week_view_title: 'Week View',
  week_view_subtitle: 'Week of %{date}',
  shifts_scheduled_count: '%{count} shift(s) scheduled',
  click_to_add_shift: 'Click to add shift',
  to: 'to',
  subtitle: 'View your assigned shifts and working hours',
  loading: 'Loading schedule...',
  stats_this_week: 'This Week',
  stats_shifts: 'Shifts',
  stats_next_shift: 'Next Shift',
  stats_none: 'None',
  shift_singular: 'shift',
  shift_plural: 'shifts',
  selected_day_notification: 'Selected %{date}',
  no_shifts_for_day: 'No shifts scheduled for this day',
  this_week_shifts_title: "This Week's Shifts",
  this_week_shifts_description: 'Your scheduled shifts for the current week',
  no_shifts_for_week: 'No shifts scheduled for this week',
  upcoming_shifts_description: 'Your next scheduled shifts',
  today_label: 'Today',
  tomorrow_label: 'Tomorrow',
  status_scheduled: 'Scheduled',
  status_confirmed: 'Confirmed',
  status_completed: 'Completed',
  status_cancelled: 'Cancelled',
  failed_to_load: 'Failed to load schedule data',
};
